/*
 * Copyright 2018-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
 * in compliance with the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations under the License.
 */

<template>
  <div
    class="awsui-tabs"
  >
    <ul class="awsui-tabs-header">
      <li
        v-for="item in titles"
        :key="item"
        :class="tabClass(item)"
        @click="selectTab(item)"
      >
        <span>{{ item }}</span>
      </li>
    </ul>
    <div class="awsui-tabs-content">
      <slot :name="selected" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AwsuiTabs',
  components: {
  },
  props: {
    titles: {
      default () {
        return []
      },
      type: Array
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  watch: {
    // titles(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.$logger.debug('awsui-tab new', newVal);
    //     this.$logger.debug('awsui-tab old', oldVal);
    //     this.selected = newVal[0];
    //   }
    // },
  },
  mounted () {
    this.selected = this.titles[0]
  },
  methods: {
    selectTab (val) {
      this.selected = val
    },
    tabClass (val) {
      if (val === this.selected) {
        return 'awsui-tabs-tab awsui-tabs-tab-active'
      }
      return 'awsui-tabs-tab'
    }
  }
}
</script>
<style>
.awsui-tabs-header {
  margin: 0;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: 1px solid #aab7b8;

  margin: .5rem 0;
  list-style-position: outside;
}
.awsui-tabs-tab {
  list-style: none;
  padding: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: block;

  border-right: 1px solid #aab7b8;

  display: inline-block;
  padding: .5rem 2rem;
  white-space: nowrap;
}
.awsui-tabs-tab:first-child {
  margin-left: 1px;
}
.awsui-tabs-tab:last-child {
  margin-right: 1px;
  border-right: 0;
}
.awsui-tabs-tab span {
  position: relative;
  display: block;
  cursor: pointer;
  border: 1px solid transparent;
  font-weight: 700;
  color: #545b64;
}
.awsui-tabs-tab-active {
  border-bottom: black solid;
}
.awsui-tabs-tab:hover span,
.awsui-tabs-tab-active span {
  color: #eb5f07;
}
</style>
